import {without} from 'lodash';

import {reportPushEvent} from '../../../src/services/heartbeat';

type PushCallback = (data: any) => void;

export class PushDispatcher {
  // Basically map PusherEvent to Callbacks.
  private eventMap: Map<string, Readonly<PushCallback[]>>;

  constructor() {
    this.eventMap = new Map();
  }

  public addCallback(eventName: string, callback: PushCallback) {
    let callbacks = this.eventMap.get(eventName) ?? [];

    callbacks = [...callbacks, callback];
    this.eventMap.set(eventName, callbacks);
  }

  public dispatchEvent(eventName: string, data: any) {
    const callbacks = this.eventMap.get(eventName);

    if (!callbacks || callbacks.length === 0) {
      reportPushEvent(eventName, true);
      return;
    }

    reportPushEvent(eventName, false);
    callbacks.forEach((callback) => callback(data));
  }

  public deleteCallback(eventName: string, callback: PushCallback) {
    const callbacks = this.eventMap.get(eventName);

    if (!callbacks) {
      return;
    }

    const newCallbacks = without(callbacks, callback);

    if (newCallbacks.length === 0) {
      this.eventMap.delete(eventName);
    } else {
      this.eventMap.set(eventName, newCallbacks);
    }
  }

  public reset() {
    this.eventMap.clear();
  }
}
